/**
 * Key của item bắt đầu sử dụng
 */
export const ItemKey = {
  /**
   * Màn Thêm danh sách phòng ban
   */
  AddDepartment: 'AddDepartment',

  /**
   * Màn thêm danh sách người dùng
   */
  AddUser: 'AddUser',

  /**
   * Màn phân quyền vai trò người dùng
   */
  ConfigUserRole: 'ConfigUserRole',

  /**
   * Thiết lập trung
   */
  ConfigGeneralSetting: 'ConfigGeneralSetting',
}

/**
 * Key dùng để lưu vào bảng user option
 */
export const OptionKey = 'viewed-page';